import { useEffect, useState } from "react";
import moment from "moment";

import DayTechItem from "./DayTechItem";
import { getMinutesFromFormattedHours, getFormattedHoursFromMins } from "src/Common/function";

const DayTimesheet = ({ timesheetData, currentDate, startDateString, timesheetUpdated, woStatus }) => {
  // useEffect(() => {
  //   console.log('timesheetData: ', timesheetData);
  // }, [timesheetData, currentDate]);

  const [totalRegularTime, setTotalRegularTime] = useState(0);
  const [totalTravelTime, setTotalTravelTime] = useState(0);
  const [totalOverTime, setTotalOverTime] = useState(0);
  const [totalTime, setTotalTime] = useState(0);
  const [activeEditingTechId, setActiveEditingTechId] = useState(null);

  // useEffect(() => {
  //   console.log('timesheetData: ', timesheetData);
  //   //calculate the total timesheet
  //   let totalRegularTime = 0;
  //   let totalTravelTime = 0;
  //   let totalOverTime = 0;
  //   for (let i = 0; i < timesheetData.length; i++) {
  //     totalRegularTime += timesheetData[i].totalTimesheet.regularTime;
  //     totalTravelTime += timesheetData[i].totalTimesheet.travelTime;
  //     totalOverTime += timesheetData[i].totalTimesheet.overTime;
  //   }
  //   setTotalRegularTime(totalRegularTime);
  //   setTotalTravelTime(totalTravelTime);
  //   setTotalOverTime(totalOverTime);
  // }, [timesheetData]);


  useEffect(() => {
    let totalRegularTimeMinutes = 0;
    let totalTravelTimeMinutes = 0;
    let totalOverTimeMinutes = 0;
    for (let tech of timesheetData) {
      // console.log("🚀 ~ DayTimesheet ~ tech:", tech)
      if (tech?.timesheet) {
        for (let i = 0; i < tech.timesheet.length; i++) {
          const workDate = moment(startDateString).add(Number(tech.timesheet[i].dayDiff || 0), "days");
          const isSameDate = workDate.isSame(currentDate, "day");
          // console.log("🚀 ~ DayTimesheet ~ workDate:", workDate, currentDate)

          if (isSameDate) {
            // console.log('isSameDate: ', isSameDate);
            console.log(tech.timesheet[i].regularTime, getMinutesFromFormattedHours(tech.timesheet[i].regularTime));
            totalRegularTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].regularTime);
            totalTravelTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].travelTime);
            totalOverTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].overTime);
          }
        }
      }
    }

    setTotalRegularTime(getFormattedHoursFromMins(totalRegularTimeMinutes));
    setTotalTravelTime(getFormattedHoursFromMins(totalTravelTimeMinutes));
    setTotalOverTime(getFormattedHoursFromMins(totalOverTimeMinutes));
    setTotalTime(getFormattedHoursFromMins(totalRegularTimeMinutes + totalTravelTimeMinutes + totalOverTimeMinutes));

  }, [timesheetData, currentDate, startDateString]);

  useEffect(() => {
    setActiveEditingTechId(null);
  }, [currentDate, startDateString]);

  return (
    <div>
      <div className="w-full h-[40px] flex items-center px-3 relative">
        <p className="font-OpenSansRegular text-[12px] font-[600] text-titleColor absolute right-[265px]">REGULAR TIME</p>
        <p className="font-OpenSansRegular text-[12px] font-[600] text-titleColor absolute right-[159px]">TRAVEL TIME</p>
        <p className="font-OpenSansRegular text-[12px] font-[600] text-titleColor absolute right-[60px]">OVER TIME</p>
      </div>
      <div className="overflow-y-auto max-h-[300px]">
        {timesheetData.map((tech) => (
          <DayTechItem
            key={tech.id}
            tech={tech}
            currentDate={currentDate}
            startDateString={startDateString}
            timesheetUpdated={timesheetUpdated}
            activeEditingTechId={activeEditingTechId}
            setActiveEditingTechId={setActiveEditingTechId}
            woStatus={woStatus}
          />
        ))}
      </div>
      <div className="w-full h-[40px] flex items-center px-3 relative bg-[#E5F0FF]">
        <p className="font-OpenSansRegular text-[14px] font-[800] text-blueColor absolute left-[5%]">Daily Total:&nbsp;{totalTime}</p>
        <p className="font-OpenSansRegular text-[14px] font-[800] text-blueColor absolute right-[38%]">{totalRegularTime}</p>
        <p className="font-OpenSansRegular text-[14px] font-[800] text-blueColor absolute right-[22%]">{totalTravelTime}</p>
        <p className="font-OpenSansRegular text-[14px] font-[800] text-blueColor absolute right-[9%]">{totalOverTime}</p>
      </div>
    </div>
  );
};

export default DayTimesheet;